import { stationOpsApi } from "../config/apiConfig";

export const getAllRfidCards = async () => {
    try {
        const response = await stationOpsApi.get("/rfid");
        return response.data;
    } catch (error) {
        console.error("Error fetching RFID cards: ", error);
        throw error;
    }
}

export const createNewRfidCard = async (uid, cardCode, validUntil = null) => {
    try {
        const response = await stationOpsApi.post("/rfid", {
            uid: uid,
            card_code: cardCode,
            valid_until: validUntil ?? null
        });
        return response.data;
    } catch (error) {
        console.error("Error creating RFID card: ", error);
        throw error;
    }
}

export const updateRfidCard = async (uid, cardCode, validUntil = null) => {
    try {
        const response = await stationOpsApi.put(`/rfid/${uid}`, {
            card_code: cardCode,
            valid_until: validUntil ?? null
        });
        return response.data;
    } catch (error) {
        console.error("Error updating RFID card: ", error);
        throw error;
    }
}

export const assignOwnerToRfidCard = async (uid, ownerEmaid) => {
    try {
        const response = await stationOpsApi.post(`/rfid/${uid}/assign`, {
            emaid: ownerEmaid,
        });
        return response.data;
    } catch (error) {
        console.error(`Error assigning RFID card ${uid} to ${ownerEmaid}: `, error);
        throw error;
    }
}

export const unassignOwnerFromRfidCard = async (uid) => {
    try {
        const response = await stationOpsApi.post(`/rfid/${uid}/unassign`);
        return response.data;
    } catch (error) {
        console.error(`Error unassigning RFID card ${uid} `, error);
        throw error;
    }
}

export const deactivateRfidCard = async (uid) => {
    try {
        const response = await stationOpsApi.post(`/rfid/${uid}/deactivate`);
        return response.data;
    } catch (error) {
        console.error(`Error deactivating RFID card`, error);
        throw error;
    }
}

export const deleteRfidCard = async (uid) => {
    try {
        const response = await stationOpsApi.delete(`/rfid/${uid}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting RFID card ${uid} `, error);
        throw error;
    }
}